import { alpha, Theme } from '@mui/material';
import { getSidenavHoverBackground, getSidenavTextColor } from '../sidenav-colors';

/** Shared ListItemButton styles for sidenav navigation links. */
export function getCommonNavButtonStyles(theme: Theme) {
  const textColor = getSidenavTextColor(theme);
  const hoverBackground = getSidenavHoverBackground(theme);
  const activeBackground = alpha(theme.palette.primary.main, 0.12);

  return {
    textTransform: 'uppercase' as const,
    color: textColor,
    '&:hover': {
      background: hoverBackground,
      color: textColor,
      '& .MuiListItemIcon-root': {
        color: textColor,
      },
    },
    '&:focus': {
      background: hoverBackground,
      color: textColor,
      '& .MuiListItemIcon-root': {
        color: textColor,
      },
    },
    '&.active': {
      background: `${activeBackground} !important`,
      boxShadow: `inset 2px 0 0 ${theme.palette.primary.main}`,
      color: textColor,
      '& .MuiListItemIcon-root': {
        fontSize: '1.2em',
        color: theme.palette.primary.main,
      },
    },
  };
}
